import React from "react";
import visionImage from "../images/about-page-img.jpg";
import OurPartnersSection from "./OurPartnersSection";
import Testimonialsabout from "./Testimonialsabout";

const About = () => {
  return (

<>
<section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>About Us</h1>
                    </div>
                </div>
            </section>


   


    <section className="vision-mission-section">
      {/* Left Side Image */}
      <div className="flex justify-center md:w-1/2 w-full">
        <img
          src={visionImage}
          alt="Tours and Travels Poster"
          className="vision-image"
        />
      </div>

      {/* Right Side Content */}
      <div className="vision-content">
        <h3 className="vision-title py-3">About Us</h3>

        <h2 className="vision-heading py-4">Meghana Cabs: Your Travel Companion</h2>
        <p className="vision-text fs-5">
         Welcome to Meghana Cabs, where our journey is defined by a steadfast dedication to serving you, our cherished customers, with unwavering excellence, reliability, and an unbreakable commitment to transforming every ride into a delightful and memorable experience. More than just a transportation service, we pride ourselves as your trusted travel companion on the road to convenience, safety, and exceptional service. Every time you choose Meghana Cabs, you're selecting a partner in your journey, one that prioritizes your comfort and satisfaction above all else. Thank you for choosing Meghana Cabs, where every ride is a testament to our passion for serving you, our valued passenger.
        </p>

        {/* <h2 className="vision-heading">Mission:</h2>
        <p className="vision-text">
          Our mission is centered on several key principles. First and foremost, we aim
          to provide our customers with transportation services that are not only safe
          but also highly dependable, ensuring our comfort and satisfaction on every
          journey. We maintain a diverse fleet of vehicles to cater to the unique needs
          and preferences of our passengers, all while upholding the highest standards
          of professionalism and safety through continuous driver training and
          empowerment.
        </p> */}
      </div>
    </section>
    <OurPartnersSection/>
    <Testimonialsabout/>
</>
  );
};

export default About;
